import { UIView, YES } from "uicore-ts"
import { RHFloatingMenuView } from "./Custom components/RH/RHFloatingMenuView"
import { RHNavbar } from "./Custom components/RH/Utils_slop/RHDesignTokens"


export interface TopBarUserMenuItem {
    title: string
    active?: boolean
    action: () => void
}


/**
 * Top-bar specialization of the shared floating menu. Page-level action menus
 * use the same component without the speech-bubble tail.
 */
export class TopBarUserMenuView extends RHFloatingMenuView {

    constructor(elementID?: string) {
        super({ elementID, hasTail: YES })
    }


    override presentFromTriggerView(
        triggerView: UIView,
        menuItems: TopBarUserMenuItem[]
    ) {
        super.presentFromTriggerView(
            triggerView,
            menuItems.map(menuItem => ({
                title: menuItem.title,
                isActive: menuItem.active,
                action: menuItem.action
            }))
        )

        const pageScale = UIView.pageScale || 1
        const viewportInset = RHNavbar.userMenuAnchorGap
        const maximumPanelHeight = Math.max(
            RHNavbar.userMenuItemHeight,
            window.innerHeight / pageScale - viewportInset * 2
        )
        if (this.frame.height > maximumPanelHeight) {
            this.frame = this.frame.rectangleWithHeight(maximumPanelHeight)
            ;(this as TopBarUserMenuView).configureWithObject({
                style: { overflowY: "auto" }
            })
            this.setNeedsLayout()
        }
        else {
            ;(this as TopBarUserMenuView).configureWithObject({
                style: { overflowY: "hidden" }
            })
        }
    }

}
